<div class="top-bar">

  <!-- Hamburger menu (visible only on tablet/mobile) -->
  <button type="button" class="top-bar__menu" [attr.aria-label]="'topBar.openMenu' | translate" (click)="menuToggle.emit()">
    <svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.6 0.6 H20.6" stroke="#3D3D3D" stroke-width="1.6" stroke-linecap="round" />
      <path d="M0.6 7   H20.6" stroke="#3D3D3D" stroke-width="1.6" stroke-linecap="round" />
      <path d="M0.6 13.4 H20.6" stroke="#3D3D3D" stroke-width="1.6" stroke-linecap="round" />
    </svg>
  </button>

  <!-- Search -->
  <div class="search">
    <input class="search__input" type="text" [placeholder]="'header.searchPlaceholder' | translate"
      [formControl]="queryControl" (keyup.enter)="onSubmit()"
      (keydown.arrowdown)="onSearchArrowDown()" (keydown.arrowup)="onSearchArrowUp()"
      (focus)="onSearchFocus()" (blur)="onSearchBlur()" />

    <button *ngIf="queryControl.value" type="button" class="search__clear" [attr.aria-label]="'common.clearSearch' | translate"
      (click)="onClear()">
      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.83856 0.838379L0.838562 9.83838" stroke="#3D3D3D" stroke-width="1.67718" stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M0.838562 0.838379L9.83856 9.83838" stroke="#3D3D3D" stroke-width="1.67718" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>

    <span class="search__divider" aria-hidden="true"></span>

    <button type="button" class="search__btn" [attr.aria-label]="'common.search' | translate" (click)="onSubmit()">
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.12586 12.1357C7.44822 12.1357 8.68295 11.7096 9.68667 10.9995L13.4626 14.7396C13.6378 14.9132 13.8688 15 14.1078 15C14.6256 15 15 14.6055 15 14.1005C15 13.8638 14.9203 13.6428 14.7451 13.4692L10.9931 9.74487C11.7817 8.7191 12.2517 7.44871 12.2517 6.06786C12.2517 2.73014 9.49549 0 6.12586 0C2.74827 0 0 2.73014 0 6.06786C0 9.40558 2.74827 12.1357 6.12586 12.1357ZM6.12586 10.8259C3.48911 10.8259 1.32236 8.67175 1.32236 6.06786C1.32236 3.46397 3.48911 1.30984 6.12586 1.30984C8.75465 1.30984 10.9294 3.46397 10.9294 6.06786C10.9294 8.67175 8.75465 10.8259 6.12586 10.8259Z"
          fill="#3D3D3D" />
      </svg>
    </button>

    <app-intent-search [query]="queryControl.value" (resultSelect)="onResultSelect($event)"
      (querySelect)="onQuerySelect($event)"></app-intent-search>
  </div>

  <!-- Quick action icons -->
  <div class="quick-actions">
    <!-- Language picker (EN/DE switcher). -->
    @if (languageMenuEnabled) {
      <app-language-menu></app-language-menu>
    }
    <!-- Quick action icons. The Syncfusion ejs-tooltip host IS the flex row and targets
       each button (rule 126: tooltips use the Syncfusion library); it reads the
       button's `title` attribute as the tooltip content. The host must be a real
       laid-out box (not display:contents) or Syncfusion can't anchor the popup and
       renders it at the page's top-left corner. -->

    <ejs-tooltip class="quick-actions__tooltip" cssClass="quick-actions__tip" target=".quick-actions__btn" position="BottomCenter">
      <button type="button" class="quick-actions__btn" data-testid="quick-action-megaphone" [title]="'breadcrumbs.whatsNew' | translate"
        [attr.aria-label]="'breadcrumbs.whatsNew' | translate" (click)="action.emit('megaphone')">
        <svg width="23" height="24" viewBox="0 0 19.1667 20.9521" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.91462 18.7451C8.59361 20.5237 6.49348 20.9042 6.49348 20.9042C5.81042 21.1459 5.68782 20.3958 5.68782 20.3958L4.25324 15.968C3.94834 14.825 3.26846 15.036 3.26846 15.036C1.54171 15.6457 0.911995 13.5781 0.911995 13.5781L0.117483 11.1291C-0.459693 9.34888 1.27741 8.64775 1.27741 8.64775L3.50809 7.8594C4.22857 7.6052 4.33763 8.31546 4.33763 8.31546L6.13523 13.9834C6.28888 14.4561 5.98159 15.4895 5.98159 15.4895C5.98159 16.9582 7.40263 17.676 6.91462 18.7451ZM15.2522 8.95678C15.749 8.40269 15.9528 7.59108 15.7028 6.82183C15.4528 6.0501 14.8199 5.53671 14.1011 5.41127L12.4261 0.24338C12.2071 -0.431993 11.903 0.512533 11.903 0.512533C10.6714 5.63308 5.20698 7.18486 5.20698 7.18486C4.57407 7.40998 4.85669 7.93749 4.85669 7.93749L6.43935 12.8171C6.62165 13.3803 7.18689 13.181 7.18689 13.181C13.1744 11.066 16.4941 14.2958 16.4941 14.2958C16.4941 14.2958 17.1637 14.7427 16.924 14.1155L15.2522 8.95678ZM17.381 2.73886L17.0793 2.51124L15.3868 4.93776L15.6877 5.16621L17.381 2.73886ZM16.3827 8.87287L18.9 10.3233L19.0807 9.98188L16.5634 8.53228L16.3827 8.87287ZM16.4034 6.88331L19.1667 6.0501L19.0624 5.67544L16.2991 6.50865L16.4034 6.88331Z"
            fill="#3D3D3D" />
        </svg>
      </button>
    </ejs-tooltip>
  </div>

  <!-- Vertical divider -->
  <span class="top-bar__divider" aria-hidden="true"></span>

  <!-- User profile dropdown -->
  <app-user-profile-menu [userName]="userName()" [avatarUrl]="userProfileUrl()">
  </app-user-profile-menu>
</div>